export default "__VITE_ASSET__vgFd2k0D__"